module.exports = {"421102001":"赤壁街道","421102002":"东湖街道","421102003":"禹王街道","421102004":"南湖街道","421102100":"路口镇","421102101":"堵城镇","421102102":"陈策楼镇","421102200":"陶店乡","421102450":"火车站开发区","421102470":"黄冈高新技术产业园区","421102471":"武汉经济技术开发区黄冈产业园管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421102.json
// module id = 1621
// module chunks = 0